/* eslint-disable no-param-reassign */
import angular from 'angular';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  journeyRecord: state.journey.activeJourneyRecord,
});

angular
  .module('myConsultApp')
  .controller(
    'journeyDetailController',
    ($ngRedux, $scope, $rootScope, $location, $http, ENV, utilities) => {
      $scope.pageURL = $location.path;
      $scope.videoPlayerConfig = {
        preload: 'none',
        sources: [],
      };

      $scope.init = () => {
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      };

      $scope.onClose = () => {
        $rootScope.closeComponent();
      };

      $scope.init();
      $scope.$on('$destroy', () => {
        $scope.unsubscribe();
        $scope.journeyRecord = null;
        $scope.setActiveJourney(null);
        if (!$rootScope.isUserPage) {
          $rootScope.userId = null;
        }
      });
    },
  )
  .directive('journeyDetail', () => {
    return {
      templateUrl: 'templates/v2/journey-detail.html',
    };
  });
